/**
 * Projet: Gestion des stagiaires
 * Auteur : Tim Allemann
 * Date : 23.09.2022
 * Description : Configurations des requêtes API pour les types d'activité pour un stage
 * Fichier : typeInternshipActivityService.js
 **/

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
const CONTROLLER = '/api/TypeIntershipActivities'

export default {
  getTypeIntershipActivities() {
    return axios.get(API_URL + CONTROLLER)
  },
  getTypeIntershipActivity(id) {
    return axios.get(API_URL + CONTROLLER + '/' + id)
  },
  postTypeIntershipActivity(typeIntershipActivity) {
    return axios.post(API_URL + CONTROLLER, typeIntershipActivity)
  },
  putTypeIntershipActivity(typeIntershipActivity) {
    return axios.put(
      API_URL +
        CONTROLLER +
        '/' +
        typeIntershipActivity.typeIntershipActivityId,
      typeIntershipActivity
    )
  },
  deleteTypeIntershipActivity(typeIntershipActivityId) {
    return axios.delete(API_URL + CONTROLLER + '/' + typeIntershipActivityId)
  }
}
